import Mock from 'mockjs'
const url = {
    test: 'http://mock.test/test', // 自定义 axios 请求的地址
}
export default [
    Mock.mock(url.test, {
        'data|5':[{
            'id|+1': 1,
            'mockName|1':['name1','name2','name3']
        }]
    })
]



//////////////////
// WEBPACK FOOTER
// ./mock/index.js
// module id = x6B4
// module chunks = 10